import Base from '../../base';

export default class Default extends Base {
  init() {
    if(this.d.template.indexOf('customers/login') == -1) return;

    this.bus.$on('vue/loaded', (d) => {this.selectTab();});
  }
  selectTab() {
    var hash = location.hash.slice(1);
    if(hash == 'recover') {
      this.s.login.current_form = 'forgot';
    }
  }
}